<pop-error-wrapper>
  <h1 title
      translate="PAGES.LOGOUT.TITLE"></h1>
  <p description
     translate="PAGES.LOGOUT.DESCRIPTION"></p>
  <button action
          class="pl-button"
          (click)="goHome()"
          translate="PAGES.LOGOUT.RECONNECT"></button>
</pop-error-wrapper>
